module.exports = __webpack_public_path__ + "img/wedding-carousel-1.aeed2c73.jpg";